import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";
import Alert from "@mui/material/Alert";
import TablePagination from "@mui/material/TablePagination";
import { useCompetitorLinkRemovalList } from "./useCompetitorLinkRemovalList";
import { CompetitorLinkRemovalRunsTable } from "./CompetitorLinkRemovalRunsTable";
import { StartButton } from "./StartButton";
import type { JSX } from "react";

const SCREEN_TITLE = "Удаление ссылок конкурентов";

export function CompetitorLinkRemovalList() {
  let competitorLinkRemovalList: JSX.Element;
  const { state, fetching, page, pageSize, setPage, setPageSize, refetch } =
    useCompetitorLinkRemovalList();
  // MUI считает страницы с нуля, экран — с единицы.
  const zeroBasedPage = page - 1;

  if (state.kind === "loading") {
    competitorLinkRemovalList = (
      <Box p={3}>
        <Typography variant="h4" mb={2}>{SCREEN_TITLE}</Typography>
        <Box display="flex" justifyContent="center" p={6}>
          <CircularProgress />
        </Box>
      </Box>
    );
  } else {
    if (state.kind === "error") {
      competitorLinkRemovalList = (
      <Box p={3}>
        <Typography variant="h4" mb={2}>{SCREEN_TITLE}</Typography>
        <Alert severity="error" action={<Button size="small" onClick={refetch}>Повторить</Button>}>
          {state.message}
        </Alert>
      </Box>
    );
    } else {
      competitorLinkRemovalList = (
    <Box p={3}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h4">{SCREEN_TITLE}</Typography>
        <StartButton />
      </Box>

      {fetching && <LinearProgress sx={{ mb: 1 }} />}

      {state.kind === "empty" ? (
        <Box textAlign="center" py={4}>
          <Typography color="text.secondary" mb={2}>
            Прогонов ещё не было. Запустите очистку сайтов-доноров от ссылок конкурентов.
          </Typography>
          <StartButton />
        </Box>
      ) : (
        <>
          <CompetitorLinkRemovalRunsTable items={state.items} />
          <TablePagination
            component="div"
            count={state.totalCount}
            page={zeroBasedPage}
            onPageChange={(_event, newPage) => setPage(newPage + 1)}
            rowsPerPage={pageSize}
            onRowsPerPageChange={(event) => setPageSize(Number(event.target.value))}
            rowsPerPageOptions={[10, 25, 50, 100]}
            labelRowsPerPage="На странице:"
            labelDisplayedRows={({ from, to, count }) => `${from}–${to} из ${count}`}
          />
        </>
      )}
    </Box>
  );
    }
  }
  return competitorLinkRemovalList;
}
